// Lightweight carousel for the Colour Pairings block. One pairing per slide.
//
// We deliberately avoid tiny-slider here: the slides contain react-save-color
// widgets, and tiny-slider clones slides (for looping and its subpixel
// viewport fix), which throws a HierarchyRequestError on those widgets. A
// simple translateX track also guarantees no next-slide "peek" at the edge.
export default function ColourPairings() {
  const carousels = document.querySelectorAll("[data-pairings-carousel]");

  carousels.forEach((carousel) => {
    const track = carousel.querySelector(".colour-pairings__track");
    if (!track) return;

    const slides = Array.from(track.children);
    const prev = carousel.querySelector(".prev");
    const next = carousel.querySelector(".next");
    const dots = Array.from(carousel.querySelectorAll(".colour-pairings__dot"));

    if (slides.length <= 1) {
      const controls = carousel.querySelector(".controls");
      if (controls) controls.hidden = true;
      const dotsList = carousel.querySelector(".colour-pairings__dots");
      if (dotsList) dotsList.hidden = true;
      return;
    }

    let index = 0;

    const update = () => {
      track.style.transform = `translateX(-${index * 100}%)`;
      if (prev) prev.classList.toggle("is-disabled", index === 0);
      if (next) next.classList.toggle("is-disabled", index === slides.length - 1);
      dots.forEach((dot, i) => dot.classList.toggle("is-active", i === index));
    };

    const goTo = (target) => {
      const clamped = Math.min(Math.max(target, 0), slides.length - 1);
      if (clamped === index) return;
      index = clamped;
      update();
    };

    if (prev) prev.addEventListener("click", () => goTo(index - 1));
    if (next) next.addEventListener("click", () => goTo(index + 1));
    dots.forEach((dot, i) => dot.addEventListener("click", () => goTo(i)));

    update();
  });
}
